import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const RedeemGuestPassButton = props => {
  const {
    onClickRedeem // via withEventHandlers
  } = props

  return (
    <ResponsiveButton
      align='left'
      onClick={onClickRedeem}
      variant='outlined'
      sx={{
        color: theme => theme.palette.text.secondary
      }}
    >
      Redeem Guest Passes (optional)
    </ResponsiveButton>
  )
}

export default RedeemGuestPassButton
